import { connect } from 'react-redux';
import { toggleScreens, updateSectionPermissions } from '../actions';
import ScreenSelection from '../components/ScreenSelection';
import { getScreenSelectionPage } from '../selectors';

const mapStateToProps = state => getScreenSelectionPage(state);

const mapDispatchToProps = dispatch => ({
    toggleScreens: (...args) => {
        dispatch(toggleScreens(...args));
    },
    updateSectionPermissions: (...args) => {
        dispatch(updateSectionPermissions(...args));
    },
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ScreenSelection);
